import ResponsiveImage from "@/components/ResponsiveImage";

export type FeaturedEventBackgroundProps = {
  /** The sharp event artwork that should remain fully visible. */
  imageSrc?: string | null;
  /** Optional wide artwork used behind the sharp image. Defaults to imageSrc. */
  blurredImageSrc?: string | null;
  className?: string;
};

/**
 * Full-bleed event artwork treatment.
 *
 * The blurred layer fills the available space with cover sizing. The sharp layer
 * sits above it with contain sizing, so a source image can be shown completely
 * without stretching or cropping its composition.
 */
export default function FeaturedEventBackground({
  imageSrc,
  blurredImageSrc = imageSrc,
  className = "",
}: FeaturedEventBackgroundProps) {
  return (
    <div className={`featured-event-background ${className}`.trim()} aria-hidden="true">
      {blurredImageSrc && <ResponsiveImage
        className="featured-event-background__blurred"
        src={blurredImageSrc}
        alt=""
        loading="eager"
        maxWidth={1600}
        sizes="100vw"
      />}
      {imageSrc && <ResponsiveImage
        className="featured-event-background__image"
        src={imageSrc}
        alt=""
        loading="eager"
        maxWidth={1600}
        sizes="100vw"
      />}
    </div>
  );
}